interface DOCSparkleIconProps {
  className?: string
}

export const DOCSparkleIcon: React.FC<DOCSparkleIconProps> = ({
  className = "text-white",
}) => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M29.9391 4.66563L29.4277 6.47852L28.9164 4.66561L27.1035 4.1543L28.9164 3.64297L29.4277 1.83008L29.9391 3.64297L31.752 4.1543L29.9391 4.66563Z"
      fill="#FFF440"
    />
    <path
      d="M36.1356 11.0406L35.2334 14.2393L34.3312 11.0406L31.1325 10.1385L34.3312 9.23627L35.2334 6.0376L36.1356 9.23627L39.3343 10.1385L36.1356 11.0406Z"
      fill="#FFF440"
    />
    <path
      d="M38.5479 3.31772L37.9502 5.43701L37.3525 3.3177L35.2332 2.71997L37.3524 2.12222L37.9502 0.00292969L38.5479 2.12222L40.6672 2.71997L38.5479 3.31772Z"
      fill="#FFF440"
    />
    <path
      d="M16.6377 5V11.6678C16.6377 12.1099 16.8133 12.5338 17.1259 12.8465C17.4385 13.1591 17.8625 13.3347 18.3046 13.3347H24.9724"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.63867 20V8.33333C1.63867 7.44928 1.98986 6.60143 2.61498 5.97631C3.2401 5.35119 4.08795 5 4.97201 5H16.6387L24.972 13.3333V20"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.51379 24H1.20085C0.970813 24 0.750198 24.0914 0.587538 24.254C0.424878 24.4167 0.333496 24.6373 0.333496 24.8674V32.9626C0.333496 33.1927 0.424878 33.4133 0.587538 33.576C0.750198 33.7386 0.970813 33.83 1.20085 33.83H3.51379C4.81733 33.83 6.06748 33.3122 6.98922 32.3904C7.91096 31.4687 8.42879 30.2185 8.42879 28.915C8.42879 27.6115 7.91096 26.3613 6.98922 25.4396C6.06748 24.5178 4.81733 24 3.51379 24ZM3.51379 32.0953H2.0682V25.7347H3.51379C4.35726 25.7347 5.16618 26.0698 5.7626 26.6662C6.35902 27.2626 6.69408 28.0715 6.69408 28.915C6.69408 29.7585 6.35902 30.5674 5.7626 31.1638C5.16618 31.7602 4.35726 32.0953 3.51379 32.0953ZM27.8214 31.306C27.9873 31.4652 28.0832 31.6837 28.0881 31.9135C28.093 32.1434 28.0064 32.3658 27.8474 32.5319C27.4717 32.937 27.0173 33.2611 26.5119 33.4843C26.0066 33.7075 25.4609 33.8252 24.9085 33.83C22.5175 33.83 20.5717 31.6255 20.5717 28.915C20.5717 26.2045 22.5175 24 24.9085 24C25.4612 24.0052 26.0069 24.1233 26.5123 24.347C27.0177 24.5708 27.472 24.8954 27.8474 25.301C27.999 25.4684 28.0793 25.6883 28.0713 25.9139C28.0634 26.1396 27.9677 26.3532 27.8047 26.5095C27.6417 26.6657 27.4241 26.7522 27.1983 26.7506C26.9725 26.749 26.7563 26.6594 26.5955 26.5009C26.381 26.2653 26.1209 26.0759 25.8308 25.9442C25.5408 25.8125 25.227 25.7412 24.9085 25.7347C23.473 25.7347 22.3064 27.1615 22.3064 28.915C22.3064 30.6685 23.473 32.0953 24.9085 32.0953C25.2268 32.0892 25.5405 32.0183 25.8305 31.8871C26.1205 31.7559 26.3808 31.567 26.5955 31.332C26.7547 31.1661 26.9732 31.0702 27.203 31.0653C27.4329 31.0604 27.6553 31.147 27.8214 31.306ZM14.5003 24C12.1093 24 10.1635 26.2045 10.1635 28.915C10.1635 31.6255 12.1093 33.83 14.5003 33.83C16.8913 33.83 18.837 31.6255 18.837 28.915C18.837 26.2045 16.8913 24 14.5003 24ZM14.5003 32.0953C13.0648 32.0953 11.8982 30.6685 11.8982 28.915C11.8982 27.1615 13.0648 25.7347 14.5003 25.7347C15.9357 25.7347 17.1023 27.1615 17.1023 28.915C17.1023 30.6685 15.9357 32.0953 14.5003 32.0953Z"
      fill="white"
    />
  </svg>
)
